module.exports = __webpack_public_path__ + "img/coin-left.6b50d5a0.svg";